export default __webpack_public_path__ + "static/media/transfer_logo_24m .4bae4837.png";